module.exports = __webpack_public_path__ + "img/toilet_female.3b4f6ed2.png";